const transformSlots = (slots, {
  hasAddOns, hasMenus, templateId, whatsIncluded, venue, gatingErrors,
} = {}) => (
  slots.map((curr) => ({
    badge: curr.reservation_config?.badge,
    colors: {
      font: curr.display_config?.color?.font,
      background: curr.display_config?.color?.background,
    },
    hasAddOns,
    hasMenus: hasMenus || curr?.has_add_ons,
    isGda: curr.is_global_dining_access,
    isPresale: curr.is_presale,
    serviceTypeId: curr.shift?.service?.type.id,
    templateId: templateId || curr.template?.id,
    time: curr.date?.start,
    type: curr.config?.type,
    token: curr.config?.token,
    whatsIncluded,
    payment: curr.payment,
    allow_bypass_payment_method: venue?.allow_bypass_payment_method,
    isEligible: curr.exclusive?.is_eligible,
    exclusiveId: curr.exclusive?.id,
    gatingErrors,
    tockAmexMktBookingUrl: curr.tock_booking_url,
  }))
);

export default transformSlots;
